import { render, staticRenderFns } from "./HomeSender.vue?vue&type=template&id=0adf2920&"
import script from "./HomeSender.vue?vue&type=script&lang=js&"
export * from "./HomeSender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports